'use client'

export function getBrowserFeatures() {
  const features: Record<string, boolean | string> = {}

  try {
    // Cookies enabled
    features['browser-cookies-enabled'] = navigator.cookieEnabled
  } catch (e) {
    // Navigator not available
  }

  // Storage availability
  features['browser-local-storage'] = checkStorageAvailable('localStorage')
  features['browser-session-storage'] = checkStorageAvailable('sessionStorage')

  try {
    // Service Worker support
    features['browser-service-worker'] = 'serviceWorker' in navigator
  } catch (e) {
    features['browser-service-worker'] = false
  }

  try {
    // Web Workers support
    features['browser-web-workers'] = 'Worker' in window
  } catch (e) {
    features['browser-web-workers'] = false
  }

  // WebGL support
  features['browser-webgl'] = checkWebGLSupport()

  try {
    // Notification permission
    if ('Notification' in window) {
      features['browser-notification-permission'] = Notification.permission
    }
  } catch (e) {
    // Notification not available
  }

  return features
}

function checkStorageAvailable(type: 'localStorage' | 'sessionStorage'): boolean {
  try {
    const storage = window[type]
    const testKey = '__storage_test__'
    storage.setItem(testKey, testKey)
    storage.removeItem(testKey)
    return true
  } catch (e) {
    return false
  }
}

function checkWebGLSupport(): boolean {
  try {
    const canvas = document.createElement('canvas')
    return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')))
  } catch (e) {
    return false
  }
}
